import { Navigate, Outlet } from 'react-router';
import { STATEMENT_REPORTING_AVAILABLE } from '@/lib/runtime/feature-flags';

/**
 * Guards the annual accounts routes only. The module itself stays reachable —
 * with the annual accounts switched off, the user lands back on the
 * transactions table, not the dashboard (unlike `ModuleGate`).
 */
export function StatementReportingGate() {
  if (!STATEMENT_REPORTING_AVAILABLE) {
    return <Navigate to="/accounting/bank" replace />;
  }

  return <Outlet />;
}
